import { useQuery } from '@tanstack/react-query';

import { api, type DayRitualStateWire } from '../lib/api-client';

/**
 * useDayRitual — S3 Abertura e Fechamento do dia (Corrente de Compromissos,
 * P2 da tese, `GET /v1/agent-dashboard/day-ritual`).
 *
 * `enabled` GATEIA O FETCH (não só o render) — o caller (`DayRitualModal`)
 * passa `enabled = hasCap && kind !== null`. Cap opt-in `operator-daily-ritual`.
 */
export function useDayRitual(
  kind: 'opening' | 'closing',
  enabled: boolean,
  since?: string,
): ReturnType<typeof useQuery<DayRitualStateWire, Error>> {
  return useQuery({
    queryKey: ['day-ritual', kind, since ?? null],
    queryFn: () => api.getDayRitual(kind, since),
    enabled,
    staleTime: 30_000,
  });
}
